import React from 'react';
import { useSelector } from 'react-redux';
import { Text } from '@eo-locale/react';
import Select from '@components/Forms/partials/Select';
import SearchDropDown from '../../Forms/partials/SearchDropDown';
import { defaultFailedResponse } from '@components/auth/fetchData';
import { trackIp } from '@utils';

const rentalBookingTypes = {
    hourly: 'Local Rental',
    one_way: 'Outstation One-Way',
    round_trip: 'Outstation Round-Trip'
};

const RentalFormStandalone = () => {
    const ENV_WEB_URL = useSelector(state => state.initState.WEB_URL ?? '');

    const [cities, setCities] = React.useState([]);
    const [rentalProducts, setRentalProducts] = React.useState([]);
    const [rentalForm, setRentalForm] = React.useState({
        trip_type: '',
        product_title: '',
        start_city: '',
        end_city: ''
    });
    const [showRentalError, setShowRentalError] = React.useState(false);

    React.useEffect(() => {
        if (!ENV_WEB_URL) return;

        fetch(`${ENV_WEB_URL}/get_city_list`)
            .then(res => res.json().catch(() => defaultFailedResponse))
            .then(data => {
                let options = Object.keys(data.data);
                options = options.map(
                    word => word.charAt(0).toUpperCase() + word.slice(1)
                );
                setCities(options);
            })
            .catch(err => console.error(err));

        fetch(`${ENV_WEB_URL}/rentals/get-rental-products`)
            .then(res => res.json().catch(() => defaultFailedResponse))
            .then(data => {
                const options = Object.values(data.data).map(
                    option => option?.product_name_mm
                );
                setRentalProducts(options);
            })
            .catch(err => console.error(err));
    }, [ENV_WEB_URL]);

    const handleSubmit = () => {
        let { trip_type, product_title, start_city, end_city } = rentalForm;

        if (trip_type === 'hourly') {
            end_city = start_city;
        }

        if (!trip_type || !product_title || !start_city || !end_city) {
            setShowRentalError(true);
            return;
        }

        setShowRentalError(false);

        trackIp('check_price_rental');

        const queryParams = new URLSearchParams({
            trip_type,
            product_title,
            start_city,
            end_city
        }).toString();

        window.location.href = `/rental-result?${queryParams}`;
    };

    return (
        <div className="block m-0">
            <div className="header">
                <h6 className="heading text-center">
                    <Text
                        id="Rental_Price_Calculator"
                        defaultMessage="Rental Price Calculator"
                    />
                </h6>
            </div>
            <div className="tab-content" id="myTabContent">
                <div
                    className="tab-pane fade  active show"
                    id="lease"
                    role="tabpanel"
                    aria-labelledby="lease-tab"
                >
                    <div className="content p-0">
                       <p>
                            <Text
                                id="Rental_desc"
                                defaultMessage="Rental Price Calculator shows the rental cost of any vehicle"
                            />
                        </p>
                       <div className="py-3 mt-2">
                        <div>
                            <div className="py-2">
                            <div className="form-group">
                                <Select
                                    className="form-control"
                                    name="rentalcategory"
                                    values={rentalBookingTypes}
                                    onChange={(e) =>{
                                        setRentalForm(prev => ({
                                            ...prev,
                                            trip_type: e.target.value
                                        }));
                                    }}
                                    label="Booking Type"
                                    />
                            </div>
                             </div>
                             <div className="py-2">
                            <div className="form-group">
                           <SearchDropDown
                             options={rentalProducts}
                             placeholder="Select Car"
                             onSelect={(value) =>
                                setRentalForm(prev => ({
                                    ...prev,
                                    product_title: value
                                }))
                            }
                           />
                            </div>
                            </div>
                            <div className="py-2">
                            <div className="form-group">
                            <SearchDropDown
                              options={cities.filter(
                                (city) =>
                                  rentalForm.trip_type === 'hourly' ||
                                  city !== rentalForm.end_city
                              )}
                             placeholder="Pickup Location"
                             onSelect={(value) =>
                                setRentalForm(prev => ({
                                    ...prev,
                                    start_city: value
                                }))
                            }
                           />
                            </div>
                            </div>
                            <div className="py-2">
                            <div className="form-group">
                            <SearchDropDown
                             options={cities.filter(
                                (city) =>
                                  rentalForm.trip_type === 'hourly' ||
                                  city !== rentalForm.start_city
                              )}
                             placeholder="Drop Location"
                             disabled={rentalForm.trip_type === 'hourly'}
                             onSelect={(value) =>
                                setRentalForm(prev => ({
                                    ...prev,
                                    end_city: value
                                }))
                             }
                            />
                            </div>
                            </div>
                            {showRentalError && (
                              <div className='text-center text-danger'>
                                Please fill all the fields
                              </div>
                            )}
                            <button
                            className="btn btn-block btn-primary"
                            id="check_price_lease"
                            type="button"
                            onClick={handleSubmit}
                        >
                            {' '}
                            Check Price
                        </button>
                        </div>
                       </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RentalFormStandalone;